<template>
  <!--begin::Dashboard-->
  <div class="row">
    <div
      class="col-md-12 col-lg-12 aos-init aos-animate content d-flex flex-column mt-1 mb-5 mx-auto"
      data-aos="fade-up"
      data-aos-delay="100"
    >
      <div class="card card-custom gutter-b">
        <div class="card-header flex-wrap border-0 pt-6 pb-0">
          <div class="card-title">
            <h3 class="card-label">
              Empresas
              <span class="d-block text-muted pt-2 font-size-sm"
                >Notificaciones</span
              >
            </h3>
          </div>
          <div class="card-toolbar">
            <!--begin::Button-->
            <router-link
              class="btn btn-primary font-weight-bolder"
              :to="{ name: 'create-notifications' }"
            >
              <span class="svg-icon svg-icon-md">
                <!--begin::Svg Icon | path:/metronic/theme/html/demo1/dist/assets/media/svg/icons/Design/Flatten.svg-->
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  version="1.1"
                >
                  <g
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <rect x="0" y="0" width="24" height="24"></rect>
                    <circle fill="#000000" cx="9" cy="15" r="6"></circle>
                    <path
                      d="M8.8012943,7.00241953 C9.83837775,5.20768121 11.7781543,4 14,4 C17.3137085,4 20,6.6862915 20,10 C20,12.2218457 18.7923188,14.1616223 16.9975805,15.1987057 C16.9991904,15.1326658 17,15.0664274 17,15 C17,10.581722 13.418278,7 9,7 C8.93357256,7 8.86733422,7.00080962 8.8012943,7.00241953 Z"
                      fill="#000000"
                      opacity="0.3"
                    ></path>
                  </g>
                </svg>
                <!--end::Svg Icon--> </span
              >Cargar Configuración</router-link
            >
            <!--end::Button-->
            <button
              @click="abirModalNotificacion(null, false)"
              class="btn btn-primary font-weight-bolder ml-5"
            >
              <i class="la la-plus"></i> Crear Notificacion
            </button>
          </div>
        </div>
        <div class="card-body">
          <!--begin: Search Form-->
          <!--begin::Search Form-->
          <div class="mb-7">
            <div class="row align-items-center">
              <div class="col-lg-9 col-xl-8">
                <div class="row align-items-center">
                  <div class="col-md-6 my-2 my-md-0">
                    <div class="input-icon">
                      <input
                        type="text"
                        class="form-control"
                        v-model="search"
                        placeholder="Buscar..."
                        id="kt_datatable_search_query"
                      />
                      <span>
                        <i class="flaticon2-search-1 text-muted"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--end::Search Form-->
          <!--begin: Datatable-->
          <v-data-table
            :headers="headers"
            :items="companiesNotification"
            :search="search"
            hide-default-footer
            :items-per-page="itemsPerPage"
            :page.sync="page"
            @page-count="pageCount = $event"
          >
            <template v-slot:item="row">
              <tr>
                <td>{{ row.item.rutEmpresaCompleto }}</td>
                <td>{{ row.item.nombre }}</td>
                <td>{{ row.item.email }}</td>
                <td class="d-flex">
                  <i
                    class="la la-edit cursor-pointer"
                    @click="abirModalNotificacion(row.item, true)"
                  ></i>
                  <i
                    class="la la-trash cursor-pointer ml-5"
                    @click="abrirModalEliminarNotificacion(row.item)"
                  ></i>
                </td>
              </tr>
            </template>
          </v-data-table>
          <v-pagination v-model="page" :length="pageCount"></v-pagination>
          <!--end: Datatable-->
        </div>
      </div>
    </div>

    <b-modal
      id="modalCrearNotificacion"
      ref="modalCrearNotificacion"
      :title="editar ? 'Actualizar Notificación' : ' Nueva Notificación'"
      cancel-title="Cancelar"
      :ok-title="editar ? 'Actualizar' : 'Crear'"
      cancel-variant="light"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group
          label="Rut Empresa"
          label-for="rutEmpresa-input"
          invalid-feedback="Rut es obligatorio"
          :state="rutEmpresaState"
        >
          <b-form-input
            :disabled="editar"
            type="number"
            placeholder="1111111"
            maxlength="9"
            required="true"
            class="form-control"
            id="rutEmpresa-input"
            v-model="$v.formNotificacion.rutEmpresa.$model"
            :state="validateState2('rutEmpresa')"
          ></b-form-input>
          <b-form-invalid-feedback id="rutEmpresa-input-live-feedback">
            Error. Favor verificar
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          v-if="!editar"
          label="Email Usuario"
          label-for="email-input"
          invalid-feedback="Email es obligatorio y debe ser un Email valido"
          :state="emailState"
        >
          <b-form-input
            id="email-input"
            v-model="$v.formNotificacion.email.$model"
            :state="validateState2('email')"
            required
          ></b-form-input>
          <b-form-invalid-feedback id="email-input-live-feedback">
            Error. Favor verificar
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group
          v-if="editar"
          label="Email Usuario"
          label-for="nuevoEmail-input"
          invalid-feedback="Email es obligatorio y debe ser un Email valido"
          :state="nuevoEmail"
        >
          <b-form-input
            id="nuevoEmail-input"
            v-model="$v.formNotificacion.nuevoEmail.$model"
            :state="validateState2('nuevoEmail')"
            required
          ></b-form-input>
          <b-form-invalid-feedback id="nuevoEmail-input-live-feedback">
            Error. Favor verificar
          </b-form-invalid-feedback>
        </b-form-group>
      </form>
    </b-modal>

    <b-modal
      id="modalEliminarNotificacion"
      ref="modalEliminarNotificacion"
      title="Confirmar"
      cancel-title="Cancelar"
      ok-title="Si, Eliminar"
      cancel-variant="light"
      @ok="eliminarNotificacion"
    >
      Eliminar Notificación
    </b-modal>
  </div>
  <!--end::Dashboard-->
</template>


<script>
import { mapState } from "vuex";
import {
  GET_COMPANIES_NOTIFICATION,
  CREATE_COMPANY_NOTIFICACION,
  UPDATE_COMPANY_NOTIFICACION,
  DELETE_COMPANY_NOTIFICACION,
} from "@/core/services/store/company.module";
import { validationMixin } from "vuelidate";

import { email, minLength, required } from "vuelidate/lib/validators";
// import { formatRut, rutEsValido } from "@/core/validators/rut.js"
import moment from "moment";
moment.locale("es");

export default {
  mixins: [validationMixin],
  name: "dashboard",
  components: {
    /*Money,*/
  },
  data() {
    return {
      rutEmpresaState: null,
      emailState: null,
      nuevoEmailState: null,
      dialog: false,
      tokenDelete: "",
      page: 1,
      pageCount: 0,
      itemsPerPage: 20,
      search: "",
      headers: [
        { text: "Rut", value: "rutEmpresa" },
        { text: "Nombre", value: "nombre" },
        { text: "Email Notificaciones", value: "email" },
        { text: "Editar", value: "editar" },
      ],
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "$ ",
        suffix: "",
        precision: 0,
        masked: false,
      },
      form: {
        documento: "",

        desde: "",
        hasta: "",
      },
      formNotificacion: {
        rutEmpresa: null,
        email: "",
        nuevoEmail: "",
      },

      editar: false,
      notificacionSeleccionada: {},
    };
  },
  mounted() {
    this.getCompaniesNotifications();
  },
  validations: {
    form: {
      documento: {
        minLength: minLength(3),
      },
      desde: {},
      hasta: {},
    },
    formNotificacion: {
      rutEmpresa: { required },
      email: { required, email, minLength: minLength(5) },
      nuevoEmail: { required, email, minLength: minLength(5) },
    },
  },
  methods: {
    //     formatRut(){
    //   this.rut = formatRut(this.rut);
    // },
    abirModalNotificacion(item, editar) {
      this.rutEmpresa = "";
      this.email = "";
      this.nuevoEmail = "";

      this.$v.formNotificacion.rutEmpresa.$model = "";
      this.$v.formNotificacion.email.$model = "";
      this.$v.formNotificacion.nuevoEmail.$model = "email@gmail.com";
      this.editar = editar;

      if (editar) {
        this.$v.formNotificacion.rutEmpresa.$model = item.rutEmpresa;
        this.$v.formNotificacion.email.$model = item.email;
        this.$v.formNotificacion.nuevoEmail.$model =
          this.$v.formNotificacion.email.$model;
      }

      this.$bvModal.show("modalCrearNotificacion");
    },
    resetModal() {
      this.rutEmpresa = null;
      this.email = null;
      this.nuevoEmail = null;
    },
    handleOk(bvModalEvent) {
      // Prevent modal from closing
      bvModalEvent.preventDefault();
      // Trigger submit handler
      this.$v.formNotificacion.$touch();

      if (this.$v.formNotificacion.$anyError) {
        return;
      }
      this.handleSubmit();
    },
    handleSubmit() {
      const rutEmpresa = this.$v.formNotificacion.rutEmpresa.$model;
      const email = this.$v.formNotificacion.email.$model;
      const nuevoEmail = this.$v.formNotificacion.nuevoEmail.$model;

      if (this.editar == false) {
        this.$store
          .dispatch(CREATE_COMPANY_NOTIFICACION, {
            rutEmpresa: parseInt(rutEmpresa),
            email,
          })
          // go to which page after successfully login
          .then((data) => {
            if (data.statusCode == 201) {
              this.$bvToast.toast(
                `La notificaión se ha agregado correctamente`,
                {
                  title: "Empresa creada exitosamente",
                  autoHideDelay: 5000,
                  variant: "success",
                  toaster: "b-toaster-top-right",
                  appendToast: false,
                }
              );
              this.$bvModal.hide("modalCrearNotificacion");
              this.getCompaniesNotifications();
            }
            if (data.statusCode == 208) {
              this.$bvToast.toast(`La notificación ya existe`, {
                title: "Error",
                autoHideDelay: 5000,
                variant: "danger",
                toaster: "b-toaster-top-right",
                appendToast: false,
              });
            }

            if (data.statusCode == 202) {
              this.$bvToast.toast(
                `Error al crear la notificación, intene nuevamente`,
                {
                  title: "Error",
                  autoHideDelay: 5000,
                  variant: "danger",
                  toaster: "b-toaster-top-right",
                  appendToast: false,
                }
              );
            }
          })
          .catch((e) => {
            this.$bvToast.toast(`${e.data.errors[0]}`, {
              title: "Error",
              autoHideDelay: 5000,
              variant: "danger",
              toaster: "b-toaster-top-right",
              appendToast: false,
            });
          });
      } else {
        this.$store
          .dispatch(UPDATE_COMPANY_NOTIFICACION, {
            rutEmpresa: parseInt(rutEmpresa),
            email,
            nuevoEmail,
          })
          // go to which page after successfully login
          .then((data) => {
            if (data.statusCode == 201) {
              this.$bvToast.toast(
                `La notificaión se ha actualizado correctamente`,
                {
                  title: "Empresa creada exitosamente",
                  autoHideDelay: 5000,
                  variant: "success",
                  toaster: "b-toaster-top-right",
                  appendToast: false,
                }
              );
              this.$bvModal.hide("modalCrearNotificacion");
              this.getCompaniesNotifications();
            }
            if (data.statusCode == 208) {
              this.$bvToast.toast(`La notificación ya existe`, {
                title: "Error",
                autoHideDelay: 5000,
                variant: "danger",
                toaster: "b-toaster-top-right",
                appendToast: false,
              });
            }
          })
          .catch((e) => {
            this.$bvToast.toast(`${e.data.errors[0]}`, {
              title: "Error",
              autoHideDelay: 5000,
              variant: "danger",
              toaster: "b-toaster-top-right",
              appendToast: false,
            });
          });
      }

      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide("modal-prevent-closing");
      });
    },
    abrirModalEliminarNotificacion(notificacion) {
      this.notificacionSeleccionada = notificacion;
      this.$bvModal.show("modalEliminarNotificacion");
    },
    eliminarNotificacion() {
      this.$store
        .dispatch(DELETE_COMPANY_NOTIFICACION, this.notificacionSeleccionada)
        // go to which page after successfully login
        .then((data) => {
          if (data.statusCode == 201) {
            this.$bvToast.toast(`Notificaión eliminada`, {
              title: "Empresa creada exitosamente",
              autoHideDelay: 5000,
              variant: "success",
              toaster: "b-toaster-top-right",
              appendToast: false,
            });
            this.$bvModal.hide("modalEliminarNotificacion");
          }
          this.getCompaniesNotifications();
        })
        .catch((e) => {
          this.$bvToast.toast(`${e.data.errors[0]}`, {
            title: "Error",
            autoHideDelay: 5000,
            variant: "danger",
            toaster: "b-toaster-top-right",
            appendToast: false,
          });
        });
    },
    validateState2(name) {
      const { $dirty, $error } = this.$v.formNotificacion[name];
      return $dirty ? !$error : null;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        documento: null,
        sucursal: null,
        desde: null,
        hasta: null,
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    onButtonClick(item) {
      console.log("click on " + item.no);
    },
    getCompaniesNotifications() {
      this.$Progress.start();
      this.$store.dispatch(GET_COMPANIES_NOTIFICATION, null).then(() => {
        this.$Progress.finish();
      });
    },
  },
  filters: {
    formatDate(value) {
      const duration = moment(value).format("DD/MM/yyyy");
      return `${duration}`;
    },

    formatTime(value) {
      const hora = moment(value).format("HH:mm:ss");
      return `${hora}`;
    },
  },
  computed: {
    ...mapState({
      companiesNotification: (state) => state.company.companiesNotification,
      errors: (state) => state.errors,
    }),
  },
};
</script>
<style>
.container {
  max-width: 1185px !important;
}
.b-form-datepicker {
  min-width: 130px;
}
.b-form-datepicker label {
  padding-bottom: 3px !important;
  padding-top: 6px;
  text-transform: none;
  white-space: nowrap !important;
  font-size: 1rem !important;
}
.b-form-datepicker .btn:not(:disabled):not(.disabled) {
  cursor: pointer;
  padding: 10px 5px;
}
.d-content-full {
  width: 100%;
}

.v-data-table .btn,
.card-toolbar .btn {
  border-radius: 0;
  -webkit-box-shadow: none;
  box-shadow: none;
  padding: 7px 20px 6px 20px;
  text-transform: uppercase;
}

.card.card-custom > .card-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  min-height: 70px;
  padding-top: 0;
  padding-bottom: 0;
  background-color: transparent;
}

.card-header:first-child {
  border-radius: calc(0.42rem - 1px) calc(0.42rem - 1px) 0 0;
}
.pt-6,
.py-6 {
  padding-top: 1.5rem !important;
}
.pb-0,
.py-0 {
  padding-bottom: 0 !important;
}
.flex-wrap {
  -ms-flex-wrap: wrap !important;
  flex-wrap: wrap !important;
}
.border-0 {
  border: 0 !important;
}
.card-header {
  padding: 2rem 2.25rem;
  margin-bottom: 0;
  background-color: #ffffff;
  border-bottom: 1px solid #ebedf3;
}
.btn.btn-primary {
  color: #ffffff;
  background-color: #3699ff;
  border-color: #3699ff;
}
.btn:not(.btn-text) {
  cursor: pointer;
}
.btn {
  outline: none !important;
  vertical-align: middle;
  -webkit-transition: color 0.15s ease, background-color 0.15s ease,
    border-color 0.15s ease, -webkit-box-shadow 0.15s ease;
  transition: color 0.15s ease, background-color 0.15s ease,
    border-color 0.15s ease, -webkit-box-shadow 0.15s ease;
  transition: color 0.15s ease, background-color 0.15s ease,
    border-color 0.15s ease, box-shadow 0.15s ease;
  transition: color 0.15s ease, background-color 0.15s ease,
    border-color 0.15s ease, box-shadow 0.15s ease,
    -webkit-box-shadow 0.15s ease;
}
.font-weight-bolder {
  font-weight: 600 !important;
}
.btn-primary {
  color: #ffffff;
  background-color: #3699ff;
  border-color: #3699ff;
  -webkit-box-shadow: none;
  box-shadow: none;
}
</style>
